import LibLoader from '../base/lib-loader'
import processOptions from './knb-use-options'

const ua = navigator.userAgent.toLowerCase()

const Agent = {
  weixin: ua.indexOf('micromessenger') !== -1,
  native: ua.indexOf('titans') !== -1,
  msc: ua.indexOf('msc') !== -1, // MSC小程序
  harmonyNative: ua.indexOf('mt_web_ua') !== -1 && ua.indexOf('micromessenger') === -1 && ua.indexOf('knb') !== -1,
  andriod_Ios_HarmonyNative:
    (ua.indexOf('mt_web_ua') !== -1 && ua.indexOf('micromessenger') === -1 && ua.indexOf('knb') !== -1) ||
    ua.indexOf('titans') !== -1,
}

// 备忘：2.x版本会有问题，如closePage，升级需测试
let src = ''
if (Agent.weixin) {
  src = 'https://s0.meituan.net/bs/knb/v1.9.4/knb.js'
} else if (Agent.native) {
  src = 'https://s0.meituan.net/bs/knb/v1.9.4/knb_titans.js'
} else if (Agent.harmonyNative) {
  src = 'https://s3plus.meituan.net/tex-external-advertising/hoteltravelknb2msiv8.js'
}

const lib = new LibLoader('lib-knb', src, () => {})

function knbUse(method: string, options: {}) {
  if (!lib) {
    // console.log('[非KNB环境]')
  }
  if (Agent.weixin && !Agent.msc) {
    wxReady(() => {
      console.log('[wx ready]')
      // 如果是微信得等wxReady KNB.share 才有值
      window.KNB && window.KNB.use(...processOptions(method, options))
    })
  } else if (Agent.andriod_Ios_HarmonyNative) {
    window.KNB &&
      window.KNB.ready(() => {
        window.KNB && window.KNB.use(...processOptions(method, options))
      })
  }
}

export default function (method: string, options: {} = {}) {
  lib &&
    lib.push(() => {
      knbUse(method, options)
    })
}

export function wxReadyOnly(callback: Function) {
  window.wx.ready(callback)
}

export function wxReady(callback: Function) {
  lib &&
    lib.push(() => {
      window.KNB &&
        window.KNB.ready(() => {
          console.log('[knb ready]')
          window.wx.ready(callback)
        })
    })
}
